import * as angular from 'angular';
import pfmtName from './pfmt.filter';

const requires = [
	pfmtName
];

export default angular.module('aps.filters', requires).name;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/filters/index.ts